export const GST_REFUND_REPORT_REQUEST = 'GST_REFUND_REPORT_REQUEST';
export const GST_REFUND_REPORT_SUCCESS = 'GST_REFUND_REPORT_SUCCESS';
export const GST_REFUND_REPORT_FAILURE = 'GST_REFUND_REPORT_FAILURE';